// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import ModifiedDropdown from '@wandb/weave/common/components/elements/ModifiedDropdown';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Dropdown = styled(ModifiedDropdown)`
  &&&&&& [role='option'],
  &&&&&& .text[role='alert'] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`;
